import { useMemo, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Drawer,
  Stack,
  Typography,
} from '@mui/material';

// project import
// import ThemeLayout from "./ThemeLayout";
import DefaultThemeMode from './ThemeMode';
// import ColorScheme from "./ColorScheme";
// import ThemeWidth from "./ThemeWidth";
// import ThemeFont from "./ThemeFont";
// import ThemeMenuLayout from "./ThemeMenuLayout";
import MainCard from 'components/MainCard';
import IconButton from 'components/@extended/IconButton';
import AnimateButton from 'components/@extended/AnimateButton';
import SimpleBar from 'components/third-party/SimpleBar';
// import useConfig from "hooks/useConfig";

// assets
import {
  // LayoutOutlined,
  HighlightOutlined,
  // BorderInnerOutlined,
  // BgColorsOutlined,
  SettingOutlined,
  CloseCircleOutlined,
  BgColorsOutlined,
  // BgColorsOutlined
  // BorderInnerOutlined,
  // FontColorsOutlined
  // FontColorsOutlined,
} from '@ant-design/icons';

// types
import { ThemeMode } from 'types/config';
import useConfig from 'hooks/useConfig';
import { FormattedMessage } from 'react-intl';
// import ThemeFont from './ThemeFont';
import ColorScheme from './ColorScheme';

// ==============================|| HEADER CONTENT - CUSTOMIZATION ||============================== //

const Customization = () => {
  const theme = useTheme();
  const {
    // container,
    // fontFamily,
    mode,
    presetColor,
    // miniDrawer,
    // themeDirection,
    // menuOrientation,
  } = useConfig();

  // eslint-disable-next-line
  // const themeLayout = useMemo(
  //   () => <ThemeLayout />,
  //   [miniDrawer, themeDirection]
  // );
  // // eslint-disable-next-line
  // const themeMenuLayout = useMemo(() => <ThemeMenuLayout />, [menuOrientation]);
  // // eslint-disable-next-line
  const themeMode = useMemo(() => <DefaultThemeMode />, [mode]);
  // eslint-disable-next-line
  const themeColor = useMemo(() => <ColorScheme />, [presetColor]);
  // eslint-disable-next-line
  // const themeWidth = useMemo(() => <ThemeWidth />, [container]);
  // eslint-disable-next-line
  // const themeFont = useMemo(() => <ThemeFont />, [fontFamily]);

  const [open, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen(!open);
  };

  const iconBackColorOpen = theme.palette.mode === ThemeMode.DARK ? 'grey.200' : 'grey.300';
  const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.75 }}>
        <IconButton
          color='secondary'
          variant='light'
          sx={{
            color: 'text.primary',
            bgcolor: open ? iconBackColorOpen : iconBackColor,
          }}
          onClick={handleToggle}
          aria-label='settings toggler'
        >
          <AnimateButton >
            <SettingOutlined />
          </AnimateButton>
        </IconButton>
      </Box>
      <Drawer
        sx={{
          zIndex: 2001,
        }}
        anchor='right'
        onClose={handleToggle}
        open={open}
        PaperProps={{
          sx: {
            width: 340,
          },
        }}
      >
        {open && (
          <MainCard
            title={<FormattedMessage id='theme_customization' />}
            sx={{
              border: 'none',
              borderRadius: 0,
              height: '100vh',
              '& .MuiCardHeader-root': {
                color:
                  theme.palette.mode === ThemeMode.LIGHT ? 'black !important' : 'white !important',
                bgcolor:
                  theme.palette.mode === ThemeMode.LIGHT ? 'primary.lighter' : 'primary.main',
                '& .MuiTypography-root': { fontSize: '1rem' },
              },
            }}
            content={false}
            secondary={
              <IconButton
                shape='rounded'
                size='small'
                onClick={handleToggle}
                sx={{
                  color:
                    theme.palette.mode === ThemeMode.LIGHT
                      ? 'black !important'
                      : 'white !important',
                }}
              >
                <CloseCircleOutlined style={{ fontSize: '1.15rem' }} />
              </IconButton>
            }
          >
            <SimpleBar
              sx={{
                '& .simplebar-content': {
                  display: 'flex',
                  flexDirection: 'column',
                },
              }}
            >
              <Box
                sx={{
                  height: 'calc(100vh - 64px)',
                  '& .MuiAccordion-root': {
                    borderColor: theme.palette.divider,
                    '& .MuiAccordionSummary-root': {
                      bgcolor: 'transparent',
                      flexDirection: 'row',
                      pl: 1,
                    },
                    '& .MuiAccordionDetails-root': {
                      border: 'none',
                    },
                    '& .Mui-expanded': {
                      color: theme.palette.primary.main,
                    },
                  },
                }}
              >
                {/* <Accordion defaultExpanded sx={{ borderTop: 'none' }}>
                  <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <IconButton
                        disableRipple
                        color="primary"
                        sx={{ bgcolor: 'primary.lighter' }}
                        onClick={handleToggle}
                        aria-label="settings toggler"
                      >
                        <LayoutOutlined />
                      </IconButton>
                      <Stack>
                        <Typography variant="subtitle1" color="textPrimary">
                          Theme Layout
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Choose your layout
                        </Typography>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>{themeLayout}</AccordionDetails>
                </Accordion>
                <Accordion defaultExpanded>
                  <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <IconButton
                        disableRipple
                        color="primary"
                        sx={{ bgcolor: 'primary.lighter' }}
                        onClick={handleToggle}
                        aria-label="settings toggler"
                      >
                        <BorderInnerOutlined />
                      </IconButton>
                      <Stack>
                        <Typography variant="subtitle1" color="textPrimary">
                          Menu Orientation
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Choose Vertical or Horizontal Menu Orientation
                        </Typography>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>{themeMenuLayout}</AccordionDetails>
                </Accordion> */}

                <Accordion defaultExpanded>
                  <AccordionSummary aria-controls='panel2d-content' id='panel2d-header'>
                    <Stack direction='row' spacing={1.25} alignItems='center'>
                      <IconButton
                        disableRipple
                        color='primary'
                        sx={{ bgcolor: 'primary.lighter' }}
                        onClick={handleToggle}
                        aria-label='settings toggler'
                      >
                        <HighlightOutlined />
                      </IconButton>
                      <Stack>
                        <Typography variant='subtitle1' color='textPrimary'>
                          <FormattedMessage id='theme_mode' />
                        </Typography>
                        <Typography variant='caption' color='textSecondary'>
                          <FormattedMessage id='choose_light_dark' />
                        </Typography>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>{themeMode}</AccordionDetails>
                </Accordion>
                {!window.location.host.split('.').includes('xatena') ? (
                  <>
                    <Accordion defaultExpanded>
                      <AccordionSummary aria-controls='panel3d-content' id='panel3d-header'>
                        <Stack direction='row' spacing={1.5} alignItems='center'>
                          <IconButton
                            disableRipple
                            color='primary'
                            sx={{ bgcolor: 'primary.lighter' }}
                            onClick={handleToggle}
                            aria-label='settings toggler'
                          >
                            <BgColorsOutlined />
                          </IconButton>
                          <Stack>
                            <Typography variant='subtitle1' color='textPrimary'>
                              Color Scheme
                            </Typography>
                            <Typography variant='caption' color='textSecondary'>
                              Choose your primary theme color
                            </Typography>
                          </Stack>
                        </Stack>
                      </AccordionSummary>
                      <AccordionDetails>{themeColor}</AccordionDetails>
                    </Accordion>
                  </>
                ) : null}

                {/* <Accordion defaultExpanded>
                  <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <IconButton
                        disableRipple
                        color="primary"
                        sx={{ bgcolor: 'primary.lighter' }}
                        onClick={handleToggle}
                        aria-label="settings toggler"
                      >
                        <BorderInnerOutlined />
                      </IconButton>
                      <Stack>
                        <Typography variant="subtitle1" color="textPrimary">
                          Layout Width
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Choose fluid or container layout
                        </Typography>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>{themeWidth}</AccordionDetails>
                </Accordion> */}
                {/* <Accordion defaultExpanded sx={{ borderBottom: 'none' }}>
                  <AccordionSummary aria-controls="panel4d-content" id="panel4d-header">
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <IconButton
                        disableRipple
                        color="primary"
                        sx={{ bgcolor: 'primary.lighter' }}
                        onClick={handleToggle}
                        aria-label="settings toggler"
                      >
                        <FontColorsOutlined />
                      </IconButton>
                      <Stack>
                        <Typography variant="subtitle1" color="textPrimary">
                          Font Family
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          Choose your font family.
                        </Typography>
                      </Stack>
                    </Stack>
                  </AccordionSummary>
                  <AccordionDetails>{themeFont}</AccordionDetails>
                </Accordion> */}
              </Box>
            </SimpleBar>
          </MainCard>
        )}
      </Drawer>
    </>
  );
};

export default Customization;
